var $48f3f33a29908d4c$exports = {};
$48f3f33a29908d4c$exports = {
    "close": `U\u{17E}daryti`,
    "notifications": `Prane\u{161}imai`
};


export {$48f3f33a29908d4c$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
